import styled from '@emotion/styled/macro'

import { flexCenter } from 'style/emotion'

const Content = styled('div')`
  ${flexCenter}

  flex-direction: column;
  height: auto;
  justify-content: flex-start;
  position: relative;
`

export { Content }
